/** Absolute API base URL (including `/api`) for SDK, extension bridge, and embeds. */
export function resolvePublicApiBase(): string {
  const apiBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (apiBase?.startsWith('http')) {
    return apiBase.replace(/\/+$/, '');
  }
  const proxyTarget = (import.meta.env.VITE_API_PROXY_TARGET as string | undefined) ?? 'http://127.0.0.1:8000';
  return `${proxyTarget.replace(/\/+$/, '')}/api`;
}
